import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Tooltip from '@material-ui/core/Tooltip';
import Box from '@material-ui/core/Box';
import Fab from '@material-ui/core/Fab';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Zoom from '@material-ui/core/Zoom';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import useStores from '../utils/useStores';

const useStyles = makeStyles(theme => ({
  scrollTop: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  fingerprint: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(8),
  }
}));

const ScrollTopButton = () => {
  const classes = useStyles();
  const { uiStore } = useStores();

  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: global.window,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = () => {
    window.scrollTo(0, 0);
  };
  const handleClickFingerprint = () => {
    uiStore.setShowCookiePreferences(true);
  }

  return (
    <Zoom in={trigger}>
      <>
        <Box
          onClick={handleClick}
          role="presentation"
          className={classes.scrollTop}
          displayPrint="none"
        >
          <Fab color="secondary" size="small" aria-label="Zum Anfang der Seite">
            <KeyboardArrowUpIcon />
          </Fab>
        </Box>
        <Tooltip title="Cookie Einstellungen">
          <Box
            onClick={handleClickFingerprint}
            role="presentation"
            className={classes.fingerprint}
            displayPrint="none"
          >
             <Fab color="secondary" size="small" aria-label="Zum Anfang der Seite">
              <FingerprintIcon />
            </Fab>
          </Box>
        </Tooltip>
      </>
    </Zoom>
  );
};

ScrollTopButton.propTypes = {};

export default ScrollTopButton;
